module.exports = __webpack_public_path__ + "assets/img/dzh-5.b39b7828.jpg";